import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_95: FaireProductEntity = {
  token: "legacy_prod_abbott-95",
  type: "product",
  name: 'Butterfly Edged Planter 7" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/05e06bb0b76d6926a515b255956f218f17685e11b8bb8eb6b5409cc0da3162db.jpeg",
  priceDollars: 28,
  isBestseller: true,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
